export const SET_IS_NEW_USER_TOUR = 'set_is_new_user_tour';
export const SET_START_ROOM_TOUR = 'set_start_room_tour';

export const SELF_ONBOARD_DEMO_USER_REQUEST = 'self_onboard_demo_user_request';
export const SELF_ONBOARD_DEMO_USER_SUCCESS = 'self_onboard_demo_user_success';
export const SELF_ONBOARD_DEMO_USER_FAILURE = 'self_onboard_demo_user_failure';
